import request from '@/utils/request'

// 查询社区小组成员列表
export function listCommunityGroupMember(query) {
  return request({
    url: '/biz/admin/community/community/group/member/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组成员分页
export function pageCommunityGroupMember(query) {
  return request({
    url: '/biz/admin/community/community/group/member/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组成员详细
export function getCommunityGroupMember(data) {
  return request({
    url: '/biz/admin/community/community/group/member/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组成员
export function addCommunityGroupMember(data) {
  return request({
    url: '/biz/admin/community/community/group/member/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组成员
export function updateCommunityGroupMember(data) {
  return request({
    url: '/biz/admin/community/community/group/member/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组成员
export function delCommunityGroupMember(data) {
  return request({
    url: '/biz/admin/community/community/group/member/delete',
    method: 'post',
    data: data
  })
}
// 审核社区小组成员
export function approveCommunityGroupMember(data) {
  return request({
    url: '/biz/admin/community/community/group/member/approve',
    method: 'post',
    data: data
  })
}
